import { ref, computed } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

function getFolderNameById(value: number): string | undefined {
    const folderMaps = store.state.general.folderMaps as { label: string; value: number }[];
    const folder = folderMaps.find((item: any) => item.value === value);
    return folder?.label;
}

function getAccessControlStyle(label: string) {

    let color = '#1677FF';
    let bg = '#1677FF33';

    if (label.includes('deny')) {
        color = '#E04C4D';
        bg = '#DE323229';
    } else if (label.includes('allow')) {
        color = '#3BCA0A';
        bg = '#3FB91533';
    } else if (label.includes('conditional')) {
        color = '#3461D3';
        bg = '#D3E0FF';
    }

    return { color, bg };
}

function getAccessControlShortLabel(label: string) {
    const l = (label || '').toLowerCase();
    if (l.includes('deny')) return 'Deny';
    if (l.includes('allow')) return 'Allow';
    if (l.includes('conditional')) return 'Conditional';
    return label;
}

const data = {
    filter: {
        title: "",
        pageName: "",
        genre: "",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "FILE EXTENSION",
                    field: "fileTypePolicyName",
                    sortable: false,
                    display: (row: any) => {
                        const fileExtension = row.fileExtension ?? "";
                        const fileTypePolicyName = row.fileTypePolicyName ?? "";
                        let html = "<div class='d-flex flex-column align-items-start'>";
                        html += "<span style='font-weight: bold; color: #01172F;'>" + fileExtension + "</span>"
                        html += "<span style='color: #01172F;'>" + fileTypePolicyName + "</span>"
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363;'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "35%",
                },
                {
                    label: "APPLICATION",
                    field: "bReadExtFromRegistry",
                    display: (row: any) => {
                        const appList = row.fileExtensionApps?.map((item: any) => {
                            const hasFolderMap = item.folderMap !== null && item.folderMap !== undefined;
                            const folderMap = hasFolderMap ? (getFolderNameById(item.folderMap) ?? "") : "";
                            const app = String(item.applicationPath || '').replace(/^\*\\/, '');
                            const displayValue = {appPath: app, folderMap:folderMap};
                            if((item.isFolderMapIdAny && item.folderMap === 0) || (item.isFolderMapIdAny && item.folderMap === null)) {
                                displayValue.appPath = `[*]\\${app}`;
                            }else if(item.folderMap === 0 || item.folderMap === undefined || item.folderMap === null) {
                                displayValue.appPath = app;
                            }else {
                                displayValue.appPath = `[${folderMap}]\\${app}`;
                            }
                            return displayValue;
                        }) || [];
                        return `<ul style="padding-left: 1.25rem; margin: 0; list-style-type: none; color: #01172F;">
        ${appList.map((app: any) => `<li>${app.appPath}</li>`).join("")}
      </ul>`;
                    },
                    sortable: false,
                    width: "25%",
                },
                {
                    label: "ACCESS CONTROL",
                    field: "driverActionOverride",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const accessControl = row.driverActionOverride ?? "";

                        const styles = accessControl != null ? getAccessControlStyle(accessControl.toLowerCase()) : { color: '#1677FF', bg: '#1677FF33' };
                        const shortLabel = getAccessControlShortLabel(accessControl);
                        return `
                            <span style='margin-left:8px;background:${styles.bg};color:${styles.color};border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'>
                                ${shortLabel}
                            </span>`;
                    },
                    width: "25%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    justify: 'justify-content-center',
                    style: { justifyItems: 'center' },
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            isLoading: true,
            showPagination: false,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES, {
                    options: options,
                    filters: {}
                });
            },
        },
    },

};

export default data;
